//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomInputText from '../custom/CustomInputText.vue'
import DateRangePicker from '../settings/DateRangePicker.vue'
import CustomRadio from '../custom/CustomRadio.vue'
import CustomSelect from '../custom/CustomSelect.vue'
import CustomCheckbox from '../custom/CustomCheckboxRound.vue'
import ListItem from '../custom/ListItem.vue'
import ModalBtn from '../modal/ModalBtn.vue'
import VideoMostConfMenu from './mainContentVideoConfs.vue'
import {CONF_TYPES} from '../../constants'
import {
    GENERATE_VC_CONF_PROPS,
} from '../../store/gettersTypes'
import {mapActions, mapGetters} from 'vuex'
import {VIDEO_CONF_NEW} from '../../store/modulesNames'
import {ACT_VC_CONF_ADD} from '../../store/actionsTypes'

export default {
    name: 'enterConferenceBody',
    components: {
        CustomInputText,
        DateRangePicker,
        CustomRadio,
        CustomSelect,
        CustomCheckbox,
        ListItem,
        ModalBtn,
        VideoMostConfMenu,
    },
    props: {
        type: {
            type: String,
            default: CONF_TYPES.VM,
            required: false,
        },
        vcLink: {
            type: String,
            default: '',
            required: false,
        },
        fio: {
            type: String,
            default: '',
            required: false,
        },
        integrationServer: {
            type: String,
            default: '',
            required: false,
        },
        showMediaToggleBtns: {
            type: Boolean,
            default: true,
            required: false,
        }
    },
    created () {
        if (this.vcLink && this.vcLink.length) {
            console.log('~~~~~~~~this.type', this.type)
            console.log('~~~~~~~~this.vcLink', this.vcLink)
            const linkData = (this[GENERATE_VC_CONF_PROPS](this.type, {link: this.vcLink}) || {})

            if (linkData.link === linkData.generatedLink) {
                this.confID = linkData.confId
                this.confPassword = linkData.pass
            } else {
                this.chosenEnterWay = 1
            }
        }
    },
    data () {
        return {
            enterWays: [
                {
                    name: this.$t('videomost.conf-enterway-id'),
                },
                {
                    name: this.$t('videomost.conf-enterway-link'),
                },
            ],
            confMode: {},
            confID: '',
            confPassword: '',
            confLink: '',
            placeholder: this.$t('videomost.conf-enterway'),
            chosenEnterWay: 0,
            participantName: '',
            defTextID: '',
            defTextPassword: '',
            defTextLink: this.vcLink ? this.vcLink : '',
            defText: '',
            isNoCamera: false,
            isNoMicrophone: false,
        }
    },
    computed: {
        ...mapGetters(VIDEO_CONF_NEW, [GENERATE_VC_CONF_PROPS]),
    },
    methods: {
        chosenWayOptionClick (way) {
            this.chosenEnterWay = way
        },
        enterConference () {
            console.log('~~~~~~~~~~~~~~~~~~~~~~enterConference')
            let props = {
                noCamera: this.isNoCamera,
                noMicrophone: this.isNoMicrophone,
            }
            let userName = this.participantName || this.fio
            if (userName) props.userName = userName
            const confProps = {}
            if (this.chosenEnterWay) confProps.link = this.confLink
            //else Object.assign(confProps, { server: this.integrationServer, confId: this.confID, pass: this.confPassword })
            else {
                let payload = {confId: this.confID, pass: this.confPassword}
                if (this.type === CONF_TYPES.VM) payload.server = this.integrationServer
                Object.assign(confProps, payload)
            }
            Object.assign(props, this[GENERATE_VC_CONF_PROPS](this.type, confProps))
            //this.modalClose()
            this[ACT_VC_CONF_ADD]({type: this.type, data: props})
        },
        ...mapActions(VIDEO_CONF_NEW, [ACT_VC_CONF_ADD]),
    },
    watch: {
        participantName(val) {
            this.$emit('participantName', val)
        },
        confID(val) {
            this.$emit('confID', val)
        },
        confPassword(val) {
            this.$emit('confPassword', val)
        },
        defTextLink(val) {
            this.$emit('defTextLink', val)
        },
    }
}
